import { PageSize, TableTypes } from '@/constant';
import { GetListSearchTypes } from '@/services';
import { CommonSelectors } from '@/stores/common';
import { CommonInquiryBoardSelectors } from '@/stores/common-inquiry-board';
import { CommonInquiryBoardAnswerSelectors } from '@/stores/common-inquiry-board-answer';
import { CommonNoticeSelectors } from '@/stores/common-notice';
import { CommonNoticeReceiveSelectors } from '@/stores/common-notice-receive';
import { ContractedForeignBusinessSelectors } from '@/stores/contracted-foreign-business';
import { DefineDocumentAreaSelectors } from '@/stores/define-document-area';
import { DeviceLogSelectors } from '@/stores/device-log';
import { DeviceMobileSelectors } from '@/stores/device-mobile';
import { DeviceTabletSelectors } from '@/stores/device-tablet';
import { DistrictAllowIpSelectors } from '@/stores/district-allow-ip';
import { FooterInfoSelectors } from '@/stores/footer-info';
import { ForeignApplicantSelectors } from '@/stores/foreign-applicant/foreign-applicant.redux';
import { ForeignProgramSelectors } from '@/stores/foreign-program/foreign-program.redux';
import { ForeignSystemUnitSelectors } from '@/stores/foreign-system-unit';
import { ForeignUserSelectors } from '@/stores/foreign-user';
import { MSelectLodgingPopupSelectors } from '@/stores/m-select-lodging-popup/m-select-lodging-popup.redux';
import { SystemUnitSelectors } from '@/stores/system-unit';
import { SystemUseTipSelectors } from '@/stores/system-use-tip';
import { SystemUserSelectors } from '@/stores/system-user';
import { WorkerApplicantSelectors } from '@/stores/worker-applicant';
import { WorkerAssignmentSelectors } from '@/stores/worker-assignment';
import { WorkerAssignmentFranchiseSelectors } from '@/stores/worker-assignment-franchise';
import { WorkerAssignmentPublicSelectors } from '@/stores/worker-assignment-public';
import { WorkerAuditMonitoringSelectors } from '@/stores/worker-audit-monitoring';
import { WorkerChangeWorkPlaceSelectors } from '@/stores/worker-change-work-place';
import { WorkerDocumentSelectors } from '@/stores/worker-document';
import { WorkerExtensionStaySelectors } from '@/stores/worker-extension-stay';
import { WorkerFranchiseSelectors } from '@/stores/worker-franchise';
import { WorkerLodgingSelectors } from '@/stores/worker-lodging';
import { WorkerProgramSelectors } from '@/stores/worker-program';
import { WorkerProgramStatusSelectors } from '@/stores/worker-program-status';
import { WorkerPublicSalarySelectors } from '@/stores/worker-public-salary';
import { WorkerRecommenderSelectors } from '@/stores/worker-recommender';
import { WorkerSalarySelectors } from '@/stores/worker-salary';
import { WorkerUnauthorizedDepartureSelectors } from '@/stores/worker-unauthorized-departure';
import { WorkerUseTipSelectors } from '@/stores/worker-use-tip';
import { WorkerUserSelectors } from '@/stores/worker-user';
import { useSelector } from 'react-redux';

const dataJson = {
	[TableTypes.NOTICE]: {
		fetching: CommonNoticeSelectors.selectFetching,
		total: CommonNoticeSelectors.selectTotal,
		params: CommonNoticeSelectors.selectParams,
		list: CommonNoticeSelectors.selectList,
	},
	[TableTypes.NOTICE_RECEIVE]: {
		fetching: CommonNoticeReceiveSelectors.selectFetching,
		total: CommonNoticeReceiveSelectors.selectTotal,
		params: CommonNoticeReceiveSelectors.selectParams,
		list: CommonNoticeReceiveSelectors.selectList,
	},
	[TableTypes.INQUIRY_BOARD]: {
		fetching: CommonInquiryBoardSelectors.selectFetching,
		total: CommonInquiryBoardSelectors.selectTotal,
		params: CommonInquiryBoardSelectors.selectParams,
		list: CommonInquiryBoardSelectors.selectList,
	},
	[TableTypes.INQUIRY_BOARD_ANSWER]: {
		fetching: CommonInquiryBoardAnswerSelectors.selectFetching,
		total: CommonInquiryBoardAnswerSelectors.selectTotal,
		params: CommonInquiryBoardAnswerSelectors.selectParams,
		list: CommonInquiryBoardAnswerSelectors.selectList,
	},

	[TableTypes.UM1_01]: {
		fetching: SystemUserSelectors.selectFetching,
		total: SystemUserSelectors.selectTotal,
		params: SystemUserSelectors.selectParams,
		list: SystemUserSelectors.selectList,
	},
	[TableTypes.ED1_01]: {
		fetching: WorkerApplicantSelectors.selectFetching,
		total: WorkerApplicantSelectors.selectTotal,
		params: WorkerApplicantSelectors.selectParams,
		list: WorkerApplicantSelectors.selectList,
	},
	[TableTypes.AR1_01]: {
		fetching: WorkerApplicantSelectors.selectFetching,
		total: WorkerApplicantSelectors.selectTotal,
		params: WorkerApplicantSelectors.selectParams,
		list: WorkerApplicantSelectors.selectList,
	},
	[TableTypes.AR1_03_RECOMMENDED]: {
		fetching: WorkerApplicantSelectors.selectFetching,
		total: WorkerApplicantSelectors.selectTotalAssignment,
		params: WorkerApplicantSelectors.selectParams,
		list: WorkerApplicantSelectors.selectApplicantRecommender,
	},
	[TableTypes.AR1_03_LODGING]: {
		fetching: WorkerApplicantSelectors.selectFetching,
		total: WorkerApplicantSelectors.selectTotalAssignment,
		params: WorkerApplicantSelectors.selectParams,
		list: WorkerApplicantSelectors.selectApplicantLodging,
	},
	[TableTypes.MM1_01]: {
		fetching: WorkerUserSelectors.selectFetching,
		total: WorkerUserSelectors.selectTotal,
		params: WorkerUserSelectors.selectParams,
		list: WorkerUserSelectors.selectList,
	},
	[TableTypes.FR1_01]: {
		fetching: WorkerFranchiseSelectors.selectFetching,
		total: WorkerFranchiseSelectors.selectTotal,
		params: WorkerFranchiseSelectors.selectParams,
		list: WorkerFranchiseSelectors.selectList,
	},
	[TableTypes.FR1_03_ASSIGNED]: {
		fetching: WorkerFranchiseSelectors.selectFetching,
		total: WorkerFranchiseSelectors.selectAssignmentTotal,
		params: WorkerFranchiseSelectors.selectAssignmentListParams,
		list: WorkerFranchiseSelectors.selectAssignmentList,
	},
	[TableTypes.FR1_03_LODGING]: {
		fetching: WorkerFranchiseSelectors.selectFetching,
		total: WorkerFranchiseSelectors.selectLodgingTotal,
		params: WorkerFranchiseSelectors.selectLodgingListParams,
		list: WorkerFranchiseSelectors.selectLodgingList,
	},
	[TableTypes.FR1_03_PROGRAM]: {
		fetching: WorkerFranchiseSelectors.selectFetching,
		total: WorkerFranchiseSelectors.selectProgramTotal,
		params: WorkerFranchiseSelectors.selectProgramListParams,
		list: WorkerFranchiseSelectors.selectProgramList,
	},
	[TableTypes.LM1_01]: {
		fetching: WorkerLodgingSelectors.selectFetching,
		total: WorkerLodgingSelectors.selectTotal,
		params: WorkerLodgingSelectors.selectParams,
		list: WorkerLodgingSelectors.selectWorkerLodgingList,
	},
	[TableTypes.RM1_01]: {
		fetching: WorkerRecommenderSelectors.selectFetching,
		total: WorkerRecommenderSelectors.selectTotal,
		params: WorkerRecommenderSelectors.selectParams,
		list: WorkerRecommenderSelectors.selectWorkerRecommenderList,
	},
	[TableTypes.RM1_03_APPLICANT]: {
		fetching: WorkerRecommenderSelectors.selectFetching,
		total: WorkerRecommenderSelectors.selectTotalApplicantList,
		params: WorkerRecommenderSelectors.selectApplicantListParams,
		list: WorkerRecommenderSelectors.selectApplicantList,
	},
	[TableTypes.PM1_01]: {
		fetching: WorkerProgramSelectors.selectFetching,
		total: WorkerProgramSelectors.selectTotal,
		params: WorkerProgramSelectors.selectParams,
		list: WorkerProgramSelectors.selectList,
	},
	[TableTypes.PM1_03_APPLICANT]: {
		fetching: WorkerProgramSelectors.selectFetching,
		total: WorkerProgramSelectors.selectApplicantTotal,
		params: WorkerProgramSelectors.selectApplicantListParams,
		list: WorkerProgramSelectors.selectApplicantList,
	},
	[TableTypes.PM1_03_FRANCHISE]: {
		fetching: WorkerProgramSelectors.selectFetching,
		total: WorkerProgramSelectors.selectFranchiseTotal,
		params: WorkerProgramSelectors.selectFranchiseListParams,
		list: WorkerProgramSelectors.selectFranchiseList,
	},
	[TableTypes.PM2_01]: {
		fetching: WorkerProgramStatusSelectors.selectFetching,
		total: WorkerProgramStatusSelectors.selectTotal,
		params: WorkerProgramStatusSelectors.selectParams,
		list: WorkerProgramStatusSelectors.selectList,
	},
	[TableTypes.AM1_01]: {
		fetching: WorkerAssignmentFranchiseSelectors.selectFetching,
		total: WorkerAssignmentFranchiseSelectors.selectTotal,
		params: WorkerAssignmentFranchiseSelectors.selectParams,
		list: WorkerAssignmentFranchiseSelectors.selectList,
	},
	[TableTypes.AM1_03_APPLICANT]: {
		fetching: WorkerAssignmentSelectors.selectAssignmentApplicantFetching,
		total: WorkerAssignmentSelectors.selectAssignmentApplicantTotal,
		params: WorkerAssignmentSelectors.selectAssignmentApplicantParams,
		list: WorkerAssignmentSelectors.selectAssignmentApplicantList,
	},
	[TableTypes.AM3_01]: {
		fetching: WorkerAssignmentSelectors.selectFetching,
		total: WorkerAssignmentSelectors.selectTotal,
		params: WorkerAssignmentSelectors.selectParams,
		list: WorkerAssignmentSelectors.selectList,
	},
	[TableTypes.DM1_01]: {
		fetching: WorkerDocumentSelectors.selectFetching,
		total: WorkerDocumentSelectors.selectTotal,
		params: WorkerDocumentSelectors.selectParams,
		list: WorkerDocumentSelectors.selectList,
	},
	[TableTypes.PA4_01]: {
		fetching: WorkerSalarySelectors.selectFetching,
		total: WorkerSalarySelectors.selectTotal,
		params: WorkerSalarySelectors.selectParams,
		list: WorkerSalarySelectors.selectWorkerSalaryList,
	},
	[TableTypes.DEFINE_DOCUMENT_AREA]: {
		fetching: DefineDocumentAreaSelectors.selectFetching,
		total: DefineDocumentAreaSelectors.selectTotal,
		params: DefineDocumentAreaSelectors.selectParams,
		list: DefineDocumentAreaSelectors.selectDefineDocumentAreaList,
	},
	[TableTypes.BM1_01]: {
		fetching: WorkerUnauthorizedDepartureSelectors.selectFetching,
		total: WorkerUnauthorizedDepartureSelectors.selectTotal,
		params: WorkerUnauthorizedDepartureSelectors.selectParams,
		list: WorkerUnauthorizedDepartureSelectors.selectList,
	},
	[TableTypes.LM1_03_APPLICANT]: {
		fetching: WorkerLodgingSelectors.selectFetching,
		total: WorkerLodgingSelectors.selectApplicantListTotal,
		params: WorkerLodgingSelectors.selectApplicantListParams,
		list: WorkerLodgingSelectors.selectLodgingApplicantList,
	},
	[TableTypes.CM1_01]: {
		fetching: SystemUnitSelectors.selectFetching,
		total: SystemUnitSelectors.selectTotal,
		params: SystemUnitSelectors.selectParams,
		list: SystemUnitSelectors.selectUnitList,
	},
	[TableTypes.WC1_01]: {
		fetching: WorkerChangeWorkPlaceSelectors.selectFetching,
		total: WorkerChangeWorkPlaceSelectors.selectTotal,
		params: WorkerChangeWorkPlaceSelectors.selectParams,
		list: WorkerChangeWorkPlaceSelectors.selectList,
	},
	[TableTypes.EM1_01]: {
		fetching: WorkerExtensionStaySelectors.selectFetching,
		total: WorkerExtensionStaySelectors.selectTotal,
		params: WorkerExtensionStaySelectors.selectParams,
		list: WorkerExtensionStaySelectors.selectList,
	},
	[TableTypes.EM1_03_APPLICANT]: {
		fetching: WorkerExtensionStaySelectors.selectFetching,
		list: WorkerExtensionStaySelectors.selectApplicantList,
		total: WorkerExtensionStaySelectors.selectTotal,
		params: WorkerExtensionStaySelectors.selectParams,
	},
	[TableTypes.UPDATE_HISTORY]: {
		fetching: CommonSelectors.selectUpdateHistoryFetching,
		list: CommonSelectors.selectUpdateHistoryList,
		total: CommonSelectors.selectUpdateHistoryTotal,
		params: CommonSelectors.selectUpdateHistoryParams,
	},
	[TableTypes.MSLP]: {
		fetching: MSelectLodgingPopupSelectors.selectFetching,
		total: MSelectLodgingPopupSelectors.selectTotal,
		params: MSelectLodgingPopupSelectors.selectParams,
		list: MSelectLodgingPopupSelectors.selectMSelectLodgingPopupList,
	},
	[TableTypes.OI2_01]: {
		fetching: ForeignUserSelectors.selectFetching,
		total: ForeignUserSelectors.selectTotal,
		params: ForeignUserSelectors.selectParams,
		list: ForeignUserSelectors.selectList,
	},
	[TableTypes.OR1_01]: {
		fetching: ForeignApplicantSelectors.selectFetching,
		total: ForeignApplicantSelectors.selectTotal,
		params: ForeignApplicantSelectors.selectParams,
		list: ForeignApplicantSelectors.selectList,
	},
	[TableTypes.OP1_01]: {
		fetching: ForeignProgramSelectors.selectFetching,
		total: ForeignProgramSelectors.selectTotal,
		params: ForeignProgramSelectors.selectParams,
		list: ForeignProgramSelectors.selectList,
	},
	[TableTypes.FOOTER_INFO]: {
		fetching: FooterInfoSelectors.selectFetching,
		total: FooterInfoSelectors.selectTotal,
		params: FooterInfoSelectors.selectParams,
		list: FooterInfoSelectors.selectFooterInfoList,
	},
	[TableTypes.DISTRICT_ALLOW_IP]: {
		fetching: DistrictAllowIpSelectors.selectFetching,
		total: DistrictAllowIpSelectors.selectTotal,
		params: DistrictAllowIpSelectors.selectParams,
		list: DistrictAllowIpSelectors.selectList,
	},
	[TableTypes.CONTRACTED_FOREIGN_BUSINESS]: {
		fetching:
			ContractedForeignBusinessSelectors.selectContractedForeignBusinessListFetching,
		total:
			ContractedForeignBusinessSelectors.selectContractedForeignBusinessListTotal,
		params:
			ContractedForeignBusinessSelectors.selectContractedForeignBusinessListParams,
		list: ContractedForeignBusinessSelectors.selectContractedForeignBusinessList,
	},
	[TableTypes.OP1_03_APPLICANT]: {
		fetching: ForeignProgramSelectors.selectFetching,
		total: ForeignProgramSelectors.selectApplicantTotal,
		params: ForeignProgramSelectors.selectApplicantListParams,
		list: ForeignProgramSelectors.selectApplicantList,
	},
	[TableTypes.CM2_01]: {
		fetching: ForeignSystemUnitSelectors.selectFetching,
		total: ForeignSystemUnitSelectors.selectTotal,
		params: ForeignSystemUnitSelectors.selectParams,
		list: ForeignSystemUnitSelectors.selectUnitList,
	},
	[TableTypes.ST1_01]: {
		fetching: WorkerUseTipSelectors.selectFetching,
		total: WorkerUseTipSelectors.selectTotal,
		params: WorkerUseTipSelectors.selectParams,
		list: WorkerUseTipSelectors.selectList,
	},
	[TableTypes.SM1_01]: {
		fetching: SystemUseTipSelectors.selectFetching,
		total: SystemUseTipSelectors.selectTotal,
		params: SystemUseTipSelectors.selectParams,
		list: SystemUseTipSelectors.selectList,
	},
	[TableTypes.PA3_01]: {
		fetching: WorkerPublicSalarySelectors.selectFetching,
		total: WorkerPublicSalarySelectors.selectTotal,
		params: WorkerPublicSalarySelectors.selectParams,
		list: WorkerPublicSalarySelectors.selectList,
	},
	[TableTypes.PA3_03_APPLICANT]: {
		fetching: WorkerPublicSalarySelectors.selectApplicantFetching,
		total: WorkerPublicSalarySelectors.selectApplicantTotal,
		params: WorkerPublicSalarySelectors.selectApplicantParams,
		list: WorkerPublicSalarySelectors.selectApplicantList,
	},
	[TableTypes.PA1_01]: {
		fetching: WorkerAssignmentPublicSelectors.selectFetching,
		total: WorkerAssignmentPublicSelectors.selectTotal,
		params: WorkerAssignmentPublicSelectors.selectParams,
		list: WorkerAssignmentPublicSelectors.selectList,
	},
	[TableTypes.PA1_03_APPLICANT]: {
		fetching: WorkerAssignmentPublicSelectors.selectFetching,
		total: WorkerAssignmentPublicSelectors.selectApplicantTotal,
		params: WorkerAssignmentPublicSelectors.selectApplicantParams,
		list: WorkerAssignmentPublicSelectors.selectApplicantList,
	},
	[TableTypes.AU1_01]: {
		fetching: WorkerAuditMonitoringSelectors.selectFetching,
		total: WorkerAuditMonitoringSelectors.selectTotal,
		params: WorkerAuditMonitoringSelectors.selectParams,
		list: WorkerAuditMonitoringSelectors.selectList,
	},
	[TableTypes.DEV_01]: {
		fetching: DeviceMobileSelectors.selectFetching,
		total: DeviceMobileSelectors.selectTotal,
		params: DeviceMobileSelectors.selectParams,
		list: DeviceMobileSelectors.selectList,
	},
	[TableTypes.DEV_03]: {
		fetching: DeviceTabletSelectors.selectFetching,
		total: DeviceTabletSelectors.selectTotal,
		params: DeviceTabletSelectors.selectParams,
		list: DeviceTabletSelectors.selectList,
	},
	[TableTypes.DEV_08]: {
		fetching: DeviceLogSelectors.selectFetching,
		total: DeviceLogSelectors.selectTotal,
		params: DeviceLogSelectors.selectParams,
		list: DeviceLogSelectors.selectList,
	},
};

type ListType<T extends TableTypes> = T extends TableTypes.NOTICE
	? ReturnType<(typeof dataJson)[TableTypes.NOTICE]['list']>
	: T extends TableTypes.INQUIRY_BOARD
		? ReturnType<(typeof dataJson)[TableTypes.INQUIRY_BOARD]['list']>
		: T extends TableTypes.UM1_01
			? ReturnType<(typeof dataJson)[TableTypes.UM1_01]['list']>
			: T extends TableTypes.MM1_01
				? ReturnType<(typeof dataJson)[TableTypes.MM1_01]['list']>
				: T extends TableTypes.FR1_01
					? ReturnType<(typeof dataJson)[TableTypes.FR1_01]['list']>
					: T extends TableTypes.LM1_01
						? ReturnType<(typeof dataJson)[TableTypes.LM1_01]['list']>
						: T extends TableTypes.PM1_01
							? ReturnType<(typeof dataJson)[TableTypes.PM1_01]['list']>
							: T extends TableTypes.PM2_01
								? ReturnType<(typeof dataJson)[TableTypes.PM2_01]['list']>
								: T extends TableTypes.DM1_01
									? ReturnType<(typeof dataJson)[TableTypes.DM1_01]['list']>
									: T extends TableTypes.PA4_01
										? ReturnType<(typeof dataJson)[TableTypes.PA4_01]['list']>
										: T extends TableTypes.DEFINE_DOCUMENT_AREA
											? ReturnType<
													(typeof dataJson)[TableTypes.DEFINE_DOCUMENT_AREA]['list']
												>
											: T extends TableTypes.BM1_01
												? ReturnType<
														(typeof dataJson)[TableTypes.BM1_01]['list']
													>
												: T extends TableTypes.CM1_01
													? ReturnType<
															(typeof dataJson)[TableTypes.CM1_01]['list']
														>
													: T extends TableTypes.AM1_01
														? ReturnType<
																(typeof dataJson)[TableTypes.AM1_01]['list']
															>
														: T extends TableTypes.RM1_01
															? ReturnType<
																	(typeof dataJson)[TableTypes.RM1_01]['list']
																>
															: T extends TableTypes.WC1_01
																? ReturnType<
																		(typeof dataJson)[TableTypes.WC1_01]['list']
																	>
																: T extends TableTypes.EM1_01
																	? ReturnType<
																			(typeof dataJson)[TableTypes.EM1_01]['list']
																		>
																	: T extends TableTypes.UPDATE_HISTORY
																		? ReturnType<
																				(typeof dataJson)[TableTypes.UPDATE_HISTORY]['list']
																			>
																		: T extends TableTypes.AM1_03_APPLICANT
																			? ReturnType<
																					(typeof dataJson)[TableTypes.AM1_03_APPLICANT]['list']
																				>
																			: T extends TableTypes.AR1_01
																				? ReturnType<
																						(typeof dataJson)[TableTypes.AR1_01]['list']
																					>
																				: T extends TableTypes.ED1_01
																					? ReturnType<
																							(typeof dataJson)[TableTypes.ED1_01]['list']
																						>
																					: T extends TableTypes.RM1_03_APPLICANT
																						? ReturnType<
																								(typeof dataJson)[TableTypes.RM1_03_APPLICANT]['list']
																							>
																						: T extends TableTypes.AR1_03_RECOMMENDED
																							? ReturnType<
																									(typeof dataJson)[TableTypes.AR1_03_RECOMMENDED]['list']
																								>
																							: T extends TableTypes.AR1_03_LODGING
																								? ReturnType<
																										(typeof dataJson)[TableTypes.AR1_03_LODGING]['list']
																									>
																								: T extends TableTypes.AM3_01
																									? ReturnType<
																											(typeof dataJson)[TableTypes.AM3_01]['list']
																										>
																									: T extends TableTypes.MSLP
																										? ReturnType<
																												(typeof dataJson)[TableTypes.MSLP]['list']
																											>
																										: T extends TableTypes.OI2_01
																											? ReturnType<
																													(typeof dataJson)[TableTypes.OI2_01]['list']
																												>
																											: T extends TableTypes.MSLP
																												? ReturnType<
																														(typeof dataJson)[TableTypes.MSLP]['list']
																													>
																												: T extends TableTypes.OI2_01
																													? ReturnType<
																															(typeof dataJson)[TableTypes.OI2_01]['list']
																														>
																													: T extends TableTypes.OR1_01
																														? ReturnType<
																																(typeof dataJson)[TableTypes.OR1_01]['list']
																															>
																														: T extends TableTypes.FOOTER_INFO
																															? ReturnType<
																																	(typeof dataJson)[TableTypes.FOOTER_INFO]['list']
																																>
																															: T extends TableTypes.CONTRACTED_FOREIGN_BUSINESS
																																? ReturnType<
																																		(typeof dataJson)[TableTypes.CONTRACTED_FOREIGN_BUSINESS]['list']
																																	>
																																: T extends TableTypes.CM2_01
																																	? ReturnType<
																																			(typeof dataJson)[TableTypes.CM2_01]['list']
																																		>
																																	: T extends TableTypes.NOTICE_RECEIVE
																																		? ReturnType<
																																				(typeof dataJson)[TableTypes.NOTICE_RECEIVE]['list']
																																			>
																																		: T extends TableTypes.INQUIRY_BOARD_ANSWER
																																			? ReturnType<
																																					(typeof dataJson)[TableTypes.INQUIRY_BOARD_ANSWER]['list']
																																				>
																																			: T extends TableTypes.ST1_01
																																				? ReturnType<
																																						(typeof dataJson)[TableTypes.ST1_01]['list']
																																					>
																																				: T extends TableTypes.SM1_01
																																					? ReturnType<
																																							(typeof dataJson)[TableTypes.SM1_01]['list']
																																						>
																																					: T extends TableTypes.PA3_01
																																						? ReturnType<
																																								(typeof dataJson)[TableTypes.PA3_01]['list']
																																							>
																																						: T extends TableTypes.PA3_03_APPLICANT
																																							? ReturnType<
																																									(typeof dataJson)[TableTypes.PA3_03_APPLICANT]['list']
																																								>
																																							: T extends TableTypes.PA1_01
																																								? ReturnType<
																																										(typeof dataJson)[TableTypes.PA1_01]['list']
																																									>
																																								: T extends TableTypes.PA1_03_APPLICANT
																																									? ReturnType<
																																											(typeof dataJson)[TableTypes.PA1_03_APPLICANT]['list']
																																										>
																																									: T extends TableTypes.AU1_01
																																										? ReturnType<
																																												(typeof dataJson)[TableTypes.AU1_01]['list']
																																											>
																																										: never;

type ParamsType<T extends TableTypes> = T extends TableTypes.UPDATE_HISTORY
	? ReturnType<(typeof dataJson)[TableTypes.UPDATE_HISTORY]['params']>
	: T extends TableTypes.AM1_03_APPLICANT
		? ReturnType<(typeof dataJson)[TableTypes.AM1_03_APPLICANT]['params']>
		: T extends TableTypes.AR1_01
			? ReturnType<(typeof dataJson)[TableTypes.AR1_01]['params']>
			: T extends TableTypes.CONTRACTED_FOREIGN_BUSINESS
				? ReturnType<
						(typeof dataJson)[TableTypes.CONTRACTED_FOREIGN_BUSINESS]['params']
					>
				: T extends TableTypes.PA3_03_APPLICANT
					? ReturnType<(typeof dataJson)[TableTypes.PA3_03_APPLICANT]['params']>
					: T extends TableTypes.PA1_03_APPLICANT
						? ReturnType<
								(typeof dataJson)[TableTypes.PA1_03_APPLICANT]['params']
							>
						: {
								page: 1;
								pageSize: PageSize.XS;
								searchTypes?: GetListSearchTypes['searchTypes'];
							};

export type OutputType<T extends TableTypes> = {
	fetching: boolean;
	total: number;
	params: ParamsType<T>;
	list: ListType<T>;
};

export const useGetListData = <T extends TableTypes>(props: {
	type?: T;
}): OutputType<T> => {
	const { type } = props;

	if (!type)
		return {
			fetching: false,
			total: 0,
			params: {} as OutputType<T>['params'],
			list: [] as any,
		};

	const fetching = useSelector(dataJson[type]?.fetching);
	const total = useSelector(dataJson[type]?.total);
	const params: OutputType<T>['params'] = useSelector(
		dataJson[type].params as any
	);
	const list: OutputType<T>['list'] = useSelector(dataJson[type]?.list as any);

	return {
		fetching,
		total,
		params,
		list,
	};
};

export default useGetListData;
